import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import React from 'react';
import { FOOTER_HEIGHT } from '../../const';

export default function ContentFooter() {
  const { classes } = useStyles();
  const today = new Date().getFullYear();
  return (
    <div className={classes.wrapper}>
      <Typography className={classes.date}>{today.toString()}</Typography>
      &copy;{' '}
      <a href="https://www.prudential.com.hk/" target="_blank" rel="noopener noreferrer" className={classes.link}>
        Prudential Hong Kong
      </a>
    </div>
  );
}

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    whiteSpace: 'pre-wrap',
    paddingLeft: 25,
    height: FOOTER_HEIGHT,
  },
  date: {
    color: '#B5B5C3',
    marginRight: 8,
    fontWeight: 500,
  },
  link: {
    '&:hover': {
      color: '#3699ff',
    },
  },
}));
